export enum TenancyFilterStatus {
  DRAFT = 'DRAFT',
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export interface TenancyFilterCategory {
  category_key: string;
  category_name: string;
}

export interface RawTenancyFilterApiResponse {
  id: string;
  tenancy_id: string;
  price_cents?: number | null;
  status: TenancyFilterStatus;
  line_item_id?: string | null;
  categories: TenancyFilterCategory[];
  custom?: any;
  billed_at?: string | null;
  created_at: string;
  updated_at: string;
}

export interface RawTenancyFilterApiCreateRequest {
  tenancy_id: string;
  price_cents?: number | null;
  line_item_id?: string | null;
  categories: TenancyFilterCategory[];
  custom?: any;
}

export enum TenancyFilterUpdateStatus {
  DRAFT = 'DRAFT',
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
}

export interface RawTenancyFilterApiUpdateRequest {
  price_cents?: number | null;
  status?: TenancyFilterUpdateStatus;
  line_item_id?: string | null;
  categories?: TenancyFilterCategory[] | null;
  custom?: any;
}

export interface RawTenancyFilterApiReplaceRequest {
  price_cents: number | null;
  status: TenancyFilterUpdateStatus;
  line_item_id: string | null;
  categories: TenancyFilterCategory[];
  custom: any;
}

export interface BillAdvertiserRequest {
  billed_cents: number;
}
